export const E_DeliveryWizard_Section = {
	PARTNER_SELECT: "PARTNER",
	USER_SELECT: "USER",
	BOX_TYPE: "BOX_TYPE",
	SUMMARY: "SUMMARY",
}
